var _path, _path2, _style;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLevels(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.51613 97.0645V114.194C9.51613 116.296 11.2203 118 13.3226 118H114.194C116.296 118 118 116.296 118 114.194V13.3226C118 11.2203 116.296 9.51613 114.194 9.51613H97.0645C94.9623 9.51613 93.2581 11.2203 93.2581 13.3226V30.4516H76.129C74.0268 30.4516 72.3226 32.1558 72.3226 34.2581V51.3871H55.1935C53.0913 51.3871 51.3871 53.0913 51.3871 55.1935V72.3226H34.2581C32.1558 72.3226 30.4516 74.0268 30.4516 76.129V93.2581H13.3226C11.2203 93.2581 9.51613 94.9623 9.51613 97.0645Z",
    fill: "#788B95"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.01868 78.7284C0.903792 77.6135 0.903792 75.8059 2.01868 74.691L74.691 2.01868C75.8059 0.903797 77.6135 0.903796 78.7284 2.01868C79.8432 3.13356 79.8432 4.94115 78.7284 6.05603L6.05603 78.7284C4.94114 79.8433 3.13356 79.8433 2.01868 78.7284Z",
    fill: "#788B95"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    xmlns: "",
    type: "text/css",
    id: "custom-page-zoom-css"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevels);
export default __webpack_public_path__ + "static/media/Levels.4313695b.svg";
export { ForwardRef as ReactComponent };